// extracted by mini-css-extract-plugin
export default {"Container":"📚19-10-2rIy1g","Error":"📚19-10-2n2hUl"};